import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-surface-cover.light.webp";
import imageDark from "../images/national-surface-cover.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-surface-cover",
  displayName: `National Surface Cover`,
  datasetProductCode: `GEOSCAPE SURFACE COVER`,
  subtitle: `Land Cover Categorization at Urban and National Scales.`,
  shortDescription: `Surface Cover is a raster dataset representing land cover categories across Australia. 
The Surface Cover theme consists of two layers: (1) Urban Surface Cover and (2) National Surface Cover. The theme consists of a digital pixel representation of the different types of ground cover of Australia. Each layer represents a different pixel resolution and coverage: Urban Surface Cover is a two-metre resolution covering pre-defined areas classified as 'urban', while National Surface Cover is a complete national coverage at a thirty-metre resolution.
Data quality and potential capture timelines will vary across Australia based on three categories. Each category has been developed based on several factors defined by the population distribution (categorised based on population size), industrial/commercial activities, the probability of natural events (e.g. flooding) and the image source. 
-	Urban (satellite source) - areas with a population greater than 200, or with significant industrial/commercial activity in a visual assessment, digitised from satellite imagery
-	Urban (aerial source) - areas with a population greater than 200, or with significant industrial/commercial activity in a visual assessment, digitised from aerial imagery
-	Rural - all other areas`,
  metadata: {
    dateAdded: 1482105600000,
    dataType: ["Raster"],
    theme: `Natural Environment`,
    totalFeatureCount: 52333,
    updateFrequency: `Quarterly`,
    license: `Commercial`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/surface_cover.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/surface_cover.html`,
  imageLight,
  imageDark,
  searchTags: `National Surface Cover Geoscape Surface Cover Cover Environmental Analysis Environmental Monitoring Land Cover Landscapes Surface Classification Terrain Urban Analysis`,
  detail: () =>
    import("../details/national-surface-cover").then((m) => m.detail),
};

export default entry;
